export const setEmployeeHalfDayData = (data = []) => {
  return data.map(({ id, nombre_dia }) => ({
    value: id,
    label: getLabel(nombre_dia),
    dayName: nombre_dia,
  }));
};

const getLabel = (day) => {
  switch (day) {
    case 'Monday':
      return 'Lunes';
    case 'Tuesday':
      return 'Martes';
    case 'Wednesday':
      return 'Miércoles';
    case 'Thursday':
      return 'Jueves';
    case 'Friday':
      return 'Viernes';
    case 'Saturday':
      return 'Sábado';
    case 'Sunday':
      return 'Domingo';
    default:
      return '';
  }
}